var _linearGradient, _linearGradient2, _linearGradient3, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _path, _path2, _path3, _use, _use2, _use3, _use4, _use5, _use6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27600 27600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 6870,
    x2: 24704,
    y1: 18705,
    y2: 18705,
    xlinkHref: "#A"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c59a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114a8b"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 16272,
    x2: 5133,
    y1: 10968,
    y2: 23102,
    xlinkHref: "#A"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b9de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "D",
    cx: 16720,
    cy: 18747,
    r: 9538,
    xlinkHref: "#A"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "E",
    cx: 7130,
    cy: 19866,
    r: 14324,
    gradientTransform: "matrix(.14843 -.98892 .79688 .1196 -8759 25542)",
    xlinkHref: "#A"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: 2523,
    cy: 4680,
    r: 20243,
    gradientTransform: "matrix(-.03715 .99931 -2.12836 -.07913 13579 3530)",
    xlinkHref: "#A"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35c1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34c1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2fc2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2bc3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36c752"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "G",
    cx: 24247,
    cy: 7758,
    r: 9734,
    gradientTransform: "matrix(.28109 .95968 -.78353 .22949 24510 -16292)",
    xlinkHref: "#A"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66eb6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66eb6e",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "M24105 20053a9345 9345 0 01-1053 472 10202 10202 0 01-3590 646c-4732 0-8855-3255-8855-7432 0-1175 680-2193 1643-2729-4280 180-5380 4640-5380 7253 0 7387 6810 8137 8276 8137 791 0 1984-230 2704-456l130-44a12834 12834 0 006660-5282c220-350-168-757-535-565z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M11571 25141a7913 7913 0 01-2273-2137 8145 8145 0 01-1514-4740 8093 8093 0 013093-6395 8082 8082 0 011373-859c312-148 846-414 1554-404a3236 3236 0 012569 1297 3184 3184 0 01636 1866c0-21 2446-7960-8005-7960-4390 0-8004 4166-8004 7820 0 2319 538 4170 1212 5604a12833 12833 0 007684 6757 12795 12795 0 003908 610c1414 0 2774-233 4045-656a7575 7575 0 01-6278-803z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M16231 15886c-80 105-330 250-330 566 0 260 170 512 472 723 1438 1003 4149 868 4156 868a5954 5954 0 003027-839 6147 6147 0 001133-850 6180 6180 0 001910-4437c26-2242-796-3732-1133-4392-2120-4141-6694-6525-11668-6525-7011 0-12703 5635-12798 12620 47-3654 3679-6605 7996-6605 350 0 2346 34 4200 1007 1634 858 2490 1894 3086 2921 618 1067 728 2415 728 2952s-271 1333-780 1990z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#B)",
    xlinkHref: "#H"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#D)",
    opacity: 0.35,
    xlinkHref: "#H"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#C)",
    xlinkHref: "#I"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#E)",
    opacity: 0.4,
    xlinkHref: "#I"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#F)",
    xlinkHref: "#J"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#G)",
    xlinkHref: "#J"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.137e3ff4063538bd800f164d7a39465f.svg";
export { ForwardRef as ReactComponent };